





















import { Component, Vue } from 'vue-property-decorator';

import Modal from './Base3.vue';

@Component({
     name: 'ProxyBannerModal',
     components: {
          Modal,
     },
})
export default class ProxyBannerModal extends Vue {}
